export const appBrandConfig = {
  name: 'Database Console',
  shortName: 'DB',
  description: 'Database Management Console',
  version: '1.0.0',
  copyright: '2026',
} as const;
